module.exports = __webpack_public_path__ + "img/cases_01.9db8acc5.jpg";